export default "__VITE_ASSET__400b67e3__"